import React from "react";
import ReusablePDFLayout from "../ReusablePDFLayout";

export const Page5 = () => {
  return (
    <ReusablePDFLayout>
      <div className="parentcls">
        <p className="bolds" style={{ margin: "15px 0" }}>
          Training & Development:
        </p>
        <p className="para">
          {/* On selection for Onshore deployment, you will be required to undergo
          training and subsequently you must enter into a bond / agreement with
          the Company. A separate agreement will be executed before deploying
          for onshore assignments. On signing the agreement, you will agree to
          stay with the company for a period of two years, failing which you
          will be liable to pay Rs. 50000/- as costs incurred by the Company for
          training, visa processing, etc. */}
          As part of employment with the Company, participation in any training program is
           required. Employees are expected to continue their employment with the Company 
           for a period depending on the duration of the training. In the event of resignation
            or separation before completing this period, a liability shall be payable to the 
            Company to cover costs incurred for training, skill development, and related 
            administrative expenses, 
          calculated based on the cost of the training. 
        </p>
        <p className="bolds" style={{ margin: "15px 0" }}>
          Certificates / Testimonials:
        </p>
        <p className="para">
          {/* At the time of your joining the Company you are required to submit
          copies of all your past and present academic and career credentials,
          if applicable, together with all the necessary documents as mentioned
          in the Offer Letter.
        </p>
        <p className="para">
          The Company reserves the right to terminate your employment in the
          event – You fail to furnish copies of certificates of your
          qualifications and experiences and / or of not receiving satisfactory
          references and certificates from your previous employers, if any, as
          regards to your satisfactory performances and conduct */}

          At the time of joining, you are required to submit copies of all relevant
           academic and professional certificates, as well as any other documents 
           specified in your Offer Letter. The Company reserves the right to terminate 
           your employment if you fail to provide these documents or if references and 
          certificates from your previous employers.  
        </p>
        <p className="bolds" style={{ marginTop: "15px" }}>
          Separation:
        </p>
        <p className="para">
          If you wish to resign your employment with the Company, you will be
          required to provide 60 days’ written notice to enable us to transition
          your work. You may alternatively be required to pay Company the notice
          period charges due for any short notice, solely at the discretion of
          the Company. This stands applicable during your Probation and after
          your confirmation of employment.
        </p>
        <p className="para">
          {/* The Company may terminate your employment without cause at any time by
          providing you with the minimum notice of 60 days or compensate you the
          basic pay in lieu of such notice and any severance pay if applicable
          and eligible and no more.
        </p>
        <p className="para">
          Notwithstanding what is stated above, your appointment maybe
          terminated forthwith without any notice or payment of any kind in case
          of:
        </p>
        <ul style={{ margin: "10px 40px" }} className="para">
          <li style={{paddingLeft:"15px"}}>Repeated willful insubordination or disobedience</li>
          <li style={{paddingLeft:"15px"}}>Proven Theft, Fraud or Dishonesty</li>
          <li style={{paddingLeft:"15px"}}>Willful damage or loss of Company’s property</li>
          <li style={{paddingLeft:"15px"}}>
            Consistent and prolonged Absence from work Or Irregularity to work
            inspite of repeated warnings
          </li>
          <li style={{paddingLeft:"15px"}}>
            Any accusation or allegations against you under Sexual Harassment of
            Women at Workplace (Prevention, Prohibition and Redressal) Act, 2013
          </li>
          <li style={{paddingLeft:"15px"}}>
            Criminal Accusation, proven guilty or convicted by any Court of Law
            during the tenure of your service with the Company.
          </li>
          <li style={{paddingLeft:"15px"}}>Being declared medically unfit to work</li>
        </ul> */}

        Employment may end either through resignation or termination in accordance
         with the Company’s policy. Resignation requires written notice to ensure a 
         smooth handover, and compensation may be required for short notice. The Company may
          terminate employment by providing notice or pay in lieu, with severance as applicable. 
          Immediate termination without notice or pay may occur in cases including disobedience, 
          theft, fraud, damage to Company property, irregular attendance, complaints under the Sexual 
          Harassment of Women at Workplace Act, criminal conviction, medical unfitness, or misuse of 
          Company property or data. 
        Notice periods and related requirements shall follow Company policy. 
        </p>

          <p className="bolds" style={{ margin: "25px 0" }}>
          Indemnity:
        </p>
        <p className="para" style={{ margin: "25px 0" }}>
 You are responsible for diligently performing your duties, maintaining the 
 confidentiality of the Company’s 
 confidential information and trade secrets, and protecting any Company
  property entrusted to you. You shall fully indemnify and keep the Company
   indemnified against any claims, demands, or losses arising from your actions or
    omissions during your employment. This obligation to indemnify the Company shall
     continue even after the termination or expiry of your employment. 
        </p>
      </div>
    </ReusablePDFLayout>
  );
};
